module.exports = __webpack_public_path__ + "img/warning.201f8afd.png";